const StateTournoi = {
    ATTENTE: "En attente",
    PRET: "Prêt",
    ENCOURS: "En cours",
    PAUSE: "En pause",
    TERMINE: "Terminé",
}

const TypeTournoi = {
    SIMPLE: "Simple",
    MIXTE: "Mixte",
    DOUBLE: "Double",
}

const ModeGeneration = {
    ALEATOIRE: "Aléatoire",
    CHAMPIONNAT: "Championnat",
}



const dbNameTournois = "generateurTournoi";

const getTournois = () => {
    const objTournois = new Tournois(dbNameTournois);
    const ls = localStorage.getItem(dbNameTournois);
    if (ls) {
        try {
            objTournois.load(ls);
            return objTournois;
        } catch (err) {
            console.error("pb chargement tournois depuis localstorage", ls, err);
            return null;
        }
    }
    return objTournois;
}

const getTournoi = (uid) => {
    const objTournois = getTournois();
    if (objTournois) {
        return objTournois.tournois.find(t => t.uid === uid);
    }
    return null;
}


class LocalObject {
    constructor() {
        this.className = null;
        this.parent = null;
        this.uid = null;
        this.persistentFields = ["className", "uid"];
    }

    setUid(uid) {
        this.uid = uid || this.className + "-" + Date.now();
    }

    load(objStr) {
        const obj = JSON.parse(objStr);
        this.persistentFields.forEach(field => {
            if (obj[field] === null) {
                this[field] = null;
            } else if (Array.isArray(obj[field])) {
                this[field] = [];
                obj[field].forEach(o => {
                    // eslint-disable-next-line 
                    const newObj = eval(`new ${o["className"]}()`);
                    newObj.load(JSON.stringify(o), this);
                    newObj.parent = this;
                    this[field].push(newObj);
                })
            } else if (typeof obj[field] === 'object') {
                // eslint-disable-next-line 
                const newObject = eval(`new ${obj["className"]}()`);
                newObject.load(obj[field], this);
                newObject.parent = this;
                this[field] = newObject;
            } else {
                this[field] = obj[field];
            }
        });
    }

    save() {
        if (this.parent === null) {
            const obj = this.buildObj();
            localStorage.setItem(this.uid, JSON.stringify(obj));
        } else {
            this.parent.save();
        }
    }

    buildObj() {
        const obj = {};
        this.persistentFields.forEach(field => {
            if (this[field] === null) {
                obj[field] = null;
            } else if (Array.isArray(this[field])) {
                obj[field] = [];
                this[field].forEach(o => {
                    obj[field].push(o.buildObj());
                })
            } else if (typeof this[field] === 'object') {
                // eslint-disable-next-line
                const newObj = eval(`new ${this["className"]}()`);
                obj[field] = newObj.buildObj();
            } else {
                obj[field] = this[field];
            }
        });
        return obj;
    }
}

class Tournois extends LocalObject {
    constructor(uid) {
        super(uid);
        this.className = "Tournois";
        this.setUid(uid);
        this.tournois = [];
        this.joueurs = [];
        this.parameters = new Parameters("parameters-" + uid);
        this.persistentFields = [...this.persistentFields, "tournois"];
    }
}

class Level extends LocalObject {
    constructor(uid, name) {
        super(uid);
        this.className = "Level";
        this.setUid(uid);
        this.levelName = name;
        this.handicapAvantage = 0;
        this.persistentFields = [...this.persistentFields, "handicapAvantage", "name"];
    }
}


class Parameters extends LocalObject {
    constructor(uid) {
        super(uid);
        this.className = "Parameters";
        this.setUid(uid);
        this.typeTournoi = TypeTournoi.MIXTE;
        this.modeGeneration = ModeGeneration.ALEATOIRE;
        this.levels = [];
        let i = 0;
        this.levels.push(new Level("level-" + uid + i++, "P12"));
        this.levels.push(new Level("level-" + uid + i++, "P11"));
        this.levels.push(new Level("level-" + uid + i++, "P10"));
        this.levels.push(new Level("level-" + uid + i++, "D9"));
        this.levels.push(new Level("level-" + uid + i++, "D8"));
        this.levels.push(new Level("level-" + uid + i++, "D7"));
        this.persistentFields = [...this.persistentFields, "modeGeneration", "levels", "typeTournoi"];
    }
}

class Tournoi extends LocalObject {
    constructor(uid, parameters) {
        super(uid);
        this.className = "Tournoi";
        this.setUid(uid);
        this.name = "";
        this.state = StateTournoi.ATTENTE;
        this.parameters = parameters;
        this.createur = null;
        this.date = -1;
        this.joueurs = [];
        this.tours = [];
        this.persistentFields = [...this.persistentFields, "name", "state", "typeTournoi", "createur", "date", "joueurs", "tours"];
    }
}

class Tour extends LocalObject {
    constructor(uid) {
        super(uid);
        this.className = "Tour";
        this.setUid(uid);
        this.terrains = [];
        this.persistentFields = [...this.persistentFields, "terrains"];
    }
}

class Terrain extends LocalObject {
    constructor(uid) {
        super(uid);
        this.className = "Terrain";
        this.setUid(uid);
        this.equipes = [];
        this.persistentFields = [...this.persistentFields, "equipes"];
    }
}

class Equipe extends LocalObject {
    constructor(uid) {
        super(uid);
        this.className = "Equipe";
        this.setUid(uid);
        this.joueurs = [];
        this.persistentFields = [...this.persistentFields, "joueurs"];
    }
}

class Joueur extends LocalObject {
    constructor(uid) {
        super(uid);
        this.className = "Joueur";
        this.setUid(uid);
        this.displayName = "";
        this.levelSimple = "NC";
        this.levelMixte = "NC";
        this.levelDouble = "NC";
        this.firstName = "";
        this.lastName = "";
        this.genderMale = true;
        this.persistentFields = [...this.persistentFields, "displayName", "levelSimple", "levelMixte", "levelDouble", "firstName", "lastName", "genderMale"];
    }
}

/*const Levels = [
    new Level("P12"),
    new Level("P11"),
    new Level("P10"),
    new Level("D9"),
    new Level("D8"),
    new Level("D7"),
]*/

export { Tournois, Tournoi, Joueur, Tour, Terrain, Equipe, StateTournoi, getTournois, getTournoi };